import script from "./EmptyStateList.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyStateList.vue?vue&type=script&setup=true&lang=js"

import "./EmptyStateList.vue?vue&type=style&index=0&id=2bf83975&lang=scss&scoped=true"
script.__scopeId = "data-v-2bf83975"

export default script